import React, { useRef } from 'react';
import emailjs from 'emailjs-com';
import './ContactForm.css';

const ContactForm = () => {
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'nahuelmf.sl@gmail.com',   // Reemplazá esto
        'prueba',  // Reemplazá esto
        formRef.current,
        'uDn8BDDQoU4wkBGIT'    // Reemplazá esto
      )
      .then(
        (result) => {
          alert('Mensaje enviado con éxito!');
          formRef.current.reset();
        },
        (error) => {
          alert('Error al enviar el mensaje. Intente más tarde.');
        }
      );
  };

  return (
    <section className="contact-section">
      <h2>Contacto</h2>
      <form ref={formRef} className="contact-form" onSubmit={sendEmail}>
        <input type="text" name="name" placeholder="Tu nombre" required />
        <input type="email" name="email" placeholder="Tu correo electrónico" required />
        <textarea name="message" placeholder="Escribí tu mensaje..." rows="5" required />
        <button type="submit">Enviar</button>
      </form>
    </section>
    
  );
};

export default ContactForm;

